import React from 'react';

import { Brand } from '@flipdish/orgmanagement';
import { styled, useTheme } from '@mui/material/styles';
import { TranslateFunction } from 'react-localize-redux';

import Tag from '@fd/ui/atoms/TagV2';

const StyledSecondaryContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

interface BrandSecondaryTextProps {
  brand: Brand;
  translate: TranslateFunction;
}

const BrandSelectorItemsSecondaryText: React.FC<BrandSecondaryTextProps> = ({
  brand,
  translate,
}) => {
  const theme = useTheme();

  if (brand?.isArchived) {
    return (
      <StyledSecondaryContainer>
        {brand.brandId}
        <Tag ownerState={{ backgroundColor: theme.palette.grey[300] }}>{translate('Archived')}</Tag>
      </StyledSecondaryContainer>
    );
  }
  return <>{brand?.brandId || ''}</>;
};

export default BrandSelectorItemsSecondaryText;
